module.exports = __webpack_public_path__ + "img/sintesis.0671615e.svg";